import { convertUtcToLocal } from "./helper";

const formatDateTime = (dateStr?: string) => {
  if (!dateStr) return "N/A";

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return convertUtcToLocal(dateStr, tz);
};

const formatDateTimeAmORPm = (dateStr?: string) => {
  if (!dateStr) return "N/A";

  //   const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return convertUtcToLocal(dateStr, "en-US", {
    dateStyle: "medium",
    timeStyle: "short",
    hour12: true,
  });
};

export { formatDateTime, formatDateTimeAmORPm };
